// extracted by mini-css-extract-plugin
export default {"stay__header":"style_stay__header__tbUBi","button_here":"style_button_here__0ReHK"};